import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { User } from '../../models/data.model';
import { Router} from '@angular/router';
import { Observable, BehaviorSubject } from 'rxjs';
import { UserService } from './user.service';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })

export class AuthenticationService {
    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;
    verfyUserDetails = new User();

    constructor(private http: HttpClient, private userService: UserService) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    login(username: string, password: string, token: string) {
        return this.http.get<User[]>(environment.apiForLogin).pipe(map((user) => {
            // tslint:disable: no-string-literal
            if (user['siteusername'] === username && user['sitepassword'] === password) {
                this.verfyUserDetails.username = user['siteusername'];
                this.verfyUserDetails.password = user['sitepassword'];
                this.verfyUserDetails.token = token;
                this.verfyUserDetails.timestamp = (new Date()).getTime();
                localStorage.setItem('currentUser', JSON.stringify(this.verfyUserDetails));
                this.currentUserSubject.next(this.verfyUserDetails);
            }
            return this.verfyUserDetails;
        }));
    }

    logout() {
        localStorage.removeItem('currentUser');
        this.currentUserSubject.next(null);
    }

}
